window.LeadActions = (function() {
	return {
		push: function(service_name, display_name, showOwnerPrompt, ids, email_id) {

			var dialogOptions = {
				header: "Contact Push",
				alert: false
			};

			if(!ids || 0 === ids.length)
			{
				dialogOptions.alert = true;
				confirmModal("No pushable contacts have been selected.", dialogOptions);
				return;
			}


			var pushFunc = function() {

				var contact_str = 'contact';
				var confirmation_text = 'Are you sure you want to push ';
				if(Array.isArray(ids))
				{
					confirmation_text += 'the selected';

					if(ids.length != 1)
						contact_str += 's';
				}
				else
				{
					ids = [ids];
					confirmation_text += 'this';
				}

				confirmation_text += ' ' + contact_str + ' to ' + display_name + '?';

				dialogOptions.resolveText = "Push";
				confirmModal(confirmation_text, dialogOptions).then(function() {
					$.ajax({
						url: '/lead/push',
						data: { id: ids, pushTo: service_name },
						type: 'POST',
						success: function(data) {

							var message_args = {
								message: 'Successfully pushed',
								type: 'success'
							};

							if(data.status != 1){
								message_args.message = 'Failed to push';
								message_args.type = 'error';
							}

                            if(email_id && data.status == 1){
                                sessionStorage.selectedLeads = JSON.stringify(ids.map(function(item) { return {contact_id: item}}));
                				window.location = '/email/send/' + email_id;
                				return;
                			} else {
                                message_args.message += ' ' + contact_str + ' to ' + display_name;
                                buildFlashMessage(message_args.message, message_args.type);
                            }
						},
						error: function(jqXHR, textStatus, errorThrown){
							var response_msg = jqXHR.responseJSON['msg'];
							var msg = response_msg + ' Unable to push ' + contact_str + ' to ' + display_name;
							var duration = 5000;

							if (jqXHR.responseJSON['failed_leads']){
								msg = response_msg;
								duration = 12000;
							}

							buildFlashMessage(msg, 'danger', '', duration);
							return;
						}
					});
				});
			};

			if(showOwnerPrompt)
			{
				confirmModal('You have selected one or more contacts that are owned by someone else.  These contacts will be omitted when pushing.', dialogOptions).then(function() {
					$('#global-alert').one('hidden.bs.modal', function() {
						pushFunc();
					});
				});
			}
			else
			{
				pushFunc();
			}
		}
	}
})();
